export function createReactHybridPageRegistry() {
  const pageTemplatesRegistry: string[] = []
  const excludedPaths = [
    '404',
  ]

  function register(templateName: string) {
    pageTemplatesRegistry.push(templateName)
  }

  function isTemplateRegistered(pageProps: any) {
    const templateName = getUniformPageTemplateName(pageProps)
    const path = getUniformPagePath(pageProps)

    if (excludedPaths.some(excludedPath => path?.includes(excludedPath))) {
      return false
    }

    return pageTemplatesRegistry.includes(templateName)
  }

  function getUniformPageTemplateName(pageProps: any) {
    return pageProps?.page?.template
  }

  return { register, isTemplateRegistered }
}

function getUniformPagePath(pageProps: any) {
  return pageProps?.fields?._url
}
